// @ts-nocheck
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Store Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackOrderHistoryExportParameters extends TrackEventBaseParameters {}

const trackHistoryExport = (
    parameters: TrackOrderHistoryExportParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "file_export", ...parameters }, options);
};

export default trackHistoryExport;
